
const getWindowLocationOrigin = () => window.location.origin


const globalWindowUtils = {
    getWindowLocationOrigin
}

export default globalWindowUtils;